export const GET_DOGS = "GET_DOGS";
export const SEARCH = "SEARCH"
export const ORD_ASC = "ORD_ASC"
export const ORD_DESC = "ORD_DESC"
export const PESO_MIN = "PESO_MIN"
export const PESO_MAX = "PESO_MAX"
export const IN_DB = "IN_DB"
export const NOT_IN_DB = "NOT_IN_DB"
export const GET_TEMPS = "GET_TEMPS"
export const TEMP = "TEMP"
export const CREATE_DOG = "CREATE_DOG"
export const GET_DOG_ID = "GET_DOG_ID"
export const CLEAR_STATE = "CLEAR_STATE"
export const PAGE = "PAGE"
export const SET_PAGE = "SET_PAGE"